module.exports = __webpack_public_path__ + "media/images/org-audience-size-icon-0ecdd2b5.svg";